export const SUPPORTED_LANGUAGES = [
    "en",
    "pl",
    "uk",
    "de",
    "ko",
] as const;
  
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];